import { useContext } from "react";
import axiosClient from "../Utils/axiosClient";
import { useTranslation } from "react-i18next";
import ToastContext from "../Context/toastContext";

const usePhoneNumberIdUpdater = () => {
  const { t } = useTranslation();
  const { showToast } = useContext(ToastContext);

  return async (account) => {
    try {
      const response = await axiosClient.get("Users/GetWhatsappInfo");

      if (response && response.data && response.data.data) {
        const whatsappInfo = response.data.data;
        let accountUpdated = false;

        whatsappInfo.forEach((datum) => {
          const cleanPhoneNumber = datum.display_phone_number
            .replace(/\s+/g, "")
            .replace("+", "");

          if (account.phoneNumber === cleanPhoneNumber) {
            account.phoneNumberId = parseInt(datum.id);
            account.isActive = true;
            accountUpdated = true;
          }
        });

        if (!accountUpdated) {
          account.phoneNumberId = 0;
          account.isActive = false;
        }
        await new Promise((resolve) => setTimeout(resolve, 1000));

        const updateResponse = await axiosClient.put("/accounts", account);

        if (
          updateResponse.status === 200 &&
          updateResponse.data.phoneNumberId !== 0
        ) {
          showToast(`${t("Whatsapp active")}`, `${t("Success")}`);
        } else {
          showToast(
            `${t("Invalid phone number. Account not activated")}`,
            `${t("Error")}`
          );
        }
      } else {
        showToast(`${t("Error fetching WhatsApp info")}`, `${t("Error")}`);
      }
    } catch (error) {
      showToast(
        `<b>${t("Error fetching WhatsApp info")}: ${t(
          "FbLoginNeeded"
        )}</b>  -  ${error}`,
        `${t("Error")}`
      );
    }
  };
};

export default usePhoneNumberIdUpdater;
